var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNofilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 320,
    viewBox: "0 0 329 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157.844,
    cy: 160,
    r: 119,
    fill: "#EEF7FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.8941,
    cy: 70.7511,
    r: 11.9,
    fill: "#EEF7FE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.743,
    cy: 228.425,
    r: 8.925,
    fill: "#EEF7FE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.4062,
    cy: 246.273,
    r: 14.875,
    fill: "#EEF7FE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.594,
    cy: 109.426,
    r: 14.875,
    fill: "#EEF7FE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 278.331,
    cy: 57.3603,
    r: 10.4125,
    fill: "#EEF7FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_6263_644361)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.029 64.8013C138.133 64.8013 116.11 77.1038 102.709 95.961C98.3331 94.9292 93.7698 94.3833 89.0789 94.3833C56.4058 94.3833 29.9189 120.87 29.9189 153.543C29.9189 186.216 56.4058 212.703 89.0789 212.703C89.2417 212.703 89.4042 212.703 89.5666 212.701H236.662C236.768 212.702 236.873 212.702 236.978 212.702C265.567 212.702 288.743 189.526 288.743 160.937C288.743 132.348 265.567 109.172 236.978 109.172C234.948 109.172 232.945 109.289 230.975 109.517C219.643 83.2146 193.486 64.8013 163.029 64.8013Z",
    fill: "#EEF7FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.0789,
    cy: 153.543,
    r: 59.16,
    fill: "url(#paint0_linear_6263_644361)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.029,
    cy: 138.751,
    r: 73.95,
    fill: "url(#paint1_linear_6263_644361)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.979,
    cy: 160.937,
    r: 51.765,
    fill: "url(#paint2_linear_6263_644361)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_6263_644361)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.193,
    y: 165.949,
    width: 83.3,
    height: 83.3,
    rx: 41.65,
    fill: "#2C74D6",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 194.37C142 194.37 146.571 192 158 192C169.429 192 174 194.37 174 194.37C174 194.37 163.238 202.226 161.429 209.778C160.458 213.829 161.429 220.444 161.429 220.444L154.571 224V209.778L142 194.37Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_6263_644361",
    x: 0.168949,
    y: 64.8008,
    width: 318.325,
    height: 207.402,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5.95,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_6263_644361"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.95
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6263_644361"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5.95,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_6263_644361"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 29.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.85
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6263_644361",
    result: "effect2_dropShadow_6263_644361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6263_644361",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_6263_644361",
    x: 104.293,
    y: 154.049,
    width: 107.1,
    height: 107.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6263_644361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6263_644361",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6263_644361",
    x1: 43.6525,
    y1: 114.455,
    x2: 148.239,
    y2: 212.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6263_644361",
    x1: 106.246,
    y1: 89.8914,
    x2: 236.979,
    y2: 212.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6263_644361",
    x1: 197.231,
    y1: 126.735,
    x2: 288.744,
    y2: 212.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNofilters);
export default "data:image/svg+xml,%3csvg width='329' height='320' viewBox='0 0 329 320' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='157.844' cy='160' r='119' fill='%23EEF7FE'/%3e %3ccircle cx='32.8941' cy='70.7511' r='11.9' fill='%23EEF7FE'/%3e %3ccircle cx='288.743' cy='228.425' r='8.925' fill='%23EEF7FE'/%3e %3ccircle cx='31.4062' cy='246.273' r='14.875' fill='%23EEF7FE'/%3e %3ccircle cx='306.594' cy='109.426' r='14.875' fill='%23EEF7FE'/%3e %3ccircle cx='278.331' cy='57.3603' r='10.4125' fill='%23EEF7FE'/%3e %3cg filter='url(%23filter0_dd_6263_644361)'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M163.029 64.8013C138.133 64.8013 116.11 77.1038 102.709 95.961C98.3331 94.9292 93.7698 94.3833 89.0789 94.3833C56.4058 94.3833 29.9189 120.87 29.9189 153.543C29.9189 186.216 56.4058 212.703 89.0789 212.703C89.2417 212.703 89.4042 212.703 89.5666 212.701H236.662C236.768 212.702 236.873 212.702 236.978 212.702C265.567 212.702 288.743 189.526 288.743 160.937C288.743 132.348 265.567 109.172 236.978 109.172C234.948 109.172 232.945 109.289 230.975 109.517C219.643 83.2146 193.486 64.8013 163.029 64.8013Z' fill='%23EEF7FE'/%3e %3ccircle cx='89.0789' cy='153.543' r='59.16' fill='url(%23paint0_linear_6263_644361)'/%3e %3ccircle cx='163.029' cy='138.751' r='73.95' fill='url(%23paint1_linear_6263_644361)'/%3e %3ccircle cx='236.979' cy='160.937' r='51.765' fill='url(%23paint2_linear_6263_644361)'/%3e %3c/g%3e %3cg filter='url(%23filter1_b_6263_644361)'%3e %3crect x='116.193' y='165.949' width='83.3' height='83.3' rx='41.65' fill='%232C74D6' fill-opacity='0.4'/%3e %3cpath d='M142 194.37C142 194.37 146.571 192 158 192C169.429 192 174 194.37 174 194.37C174 194.37 163.238 202.226 161.429 209.778C160.458 213.829 161.429 220.444 161.429 220.444L154.571 224V209.778L142 194.37Z' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/g%3e %3cdefs%3e %3cfilter id='filter0_dd_6263_644361' x='0.168949' y='64.8008' width='318.325' height='207.402' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeMorphology radius='5.95' operator='erode' in='SourceAlpha' result='effect1_dropShadow_6263_644361'/%3e %3cfeOffset dy='11.9'/%3e %3cfeGaussianBlur stdDeviation='5.95'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_6263_644361'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeMorphology radius='5.95' operator='erode' in='SourceAlpha' result='effect2_dropShadow_6263_644361'/%3e %3cfeOffset dy='29.75'/%3e %3cfeGaussianBlur stdDeviation='17.85'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0'/%3e %3cfeBlend mode='normal' in2='effect1_dropShadow_6263_644361' result='effect2_dropShadow_6263_644361'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_6263_644361' result='shape'/%3e %3c/filter%3e %3cfilter id='filter1_b_6263_644361' x='104.293' y='154.049' width='107.1' height='107.1' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeGaussianBlur in='BackgroundImageFix' stdDeviation='5.95'/%3e %3cfeComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_6263_644361'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_backgroundBlur_6263_644361' result='shape'/%3e %3c/filter%3e %3clinearGradient id='paint0_linear_6263_644361' x1='43.6525' y1='114.455' x2='148.239' y2='212.703' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3clinearGradient id='paint1_linear_6263_644361' x1='106.246' y1='89.8914' x2='236.979' y2='212.701' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3clinearGradient id='paint2_linear_6263_644361' x1='197.231' y1='126.735' x2='288.744' y2='212.702' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3c/defs%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };